import React, { useEffect } from "react";

import { Typography } from "@material-ui/core";
import { BasicPagination } from "components/utils";
import ListEmpty from "../listEmpty/ListEmpty";

import { Desktop, TabletAndMobile } from "components/utils/MediaQuery"; //2022-07-21 미디어쿼리 추가
import { useAppSettings } from "common/hooks";
import useSearchBar from "components/layout/hooks/useSearchBar";
import useSearchResult from "./hooks/useSearchResult";
import useQueryParams from "common/hooks/useQueryParams";

import LoadingWrapper from "components/idle/LoadingWrapper";
import SearchBar from "components/layout/SearchBar";
import SubHeader from "components/layout/SubHeader";
import Banner from "../../components/banner/Banner";
import ClassCardMap from "components/classCardItem/classCardMap";

import "assets/css/category.css";
import Header from "components/layout/Header";

function SearchResult() {
  const seachbarHandles = useSearchBar();
  const { popularKeywords, handlePopularClick } = seachbarHandles;
  const { screenTypes, updateHeaderVisible } = useAppSettings();
  const { keyword } = useQueryParams();
  const { classes, banner, classesStatus, paginationInput, sortType } =
    useSearchResult(keyword || "");

  useEffect(() => {
    sessionStorage.setItem("searchKeyword", keyword);
    return () => {
      sessionStorage.removeItem("searchKeyword");
    };
  }, [keyword]);

  /* useEffect(() => {
    updateHeaderVisible(screenTypes.isDesktop);
  }, [screenTypes.isDesktop]); */

  return (
    <div className="search-wrap">
      {classesStatus.isLoading && <div className="sub-fallback-margin"></div>}

      {/* <TabletAndMobile>
        <SubHeader isSearch>
          <SearchBar
            keyword={keyword}
            hideOption
            seachbarHandles={seachbarHandles}
          />
        </SubHeader>
      </TabletAndMobile> */}

      <LoadingWrapper status={[classesStatus]}>
        <>
          {classes[0]?.length > 0 ? (
            <>
              <div className="sub-wrap search-result">
                <div className="category-Container">
                  {classes[1]?.has_banner && <Banner banner={classes[1]} />}
                  <Typography
                    className="fs16 c-pc3 font-kr-bold search-result-title"
                    style={{ width: "100%", textAlign: "left", margin: "2%" }}
                  >
                    {keyword} <span className="c-ac8">{classes[0].length}</span>
                    개의 검색결과
                  </Typography>
                  <ClassCardMap classList={classes[0]} type={"class"} />
                </div>

                {/* <Desktop>
                  <BasicPagination
                    page={paginationInput.page}
                    count={paginationInput.pageCount}
                    onChange={paginationInput.onPageChange}
                  />
                </Desktop> */}
              </div>
            </>
          ) : (
            <ListEmpty isSearchEmpty />
          )}
        </>
      </LoadingWrapper>
    </div>
  );
}

export default SearchResult;
